import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=46e96a7a"
import script from "./CustomForm.vue?vue&type=script&lang=js"
export * from "./CustomForm.vue?vue&type=script&lang=js"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=46e96a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EditorTipTap: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorTipTap.js').default,EditorList: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorList.js').default,UiInputComponent: require('/home/node/app/components/ui/InputComponent.vue').default,UiCheckboxComponent: require('/home/node/app/components/ui/CheckboxComponent.vue').default,UiRadioComponent: require('/home/node/app/components/ui/RadioComponent.vue').default,ControllerPublicUpload: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerPublicUpload.js').default,UiIconsUpload: require('/home/node/app/components/ui/icons/upload.vue').default,UiIconsClose: require('/home/node/app/components/ui/icons/close.vue').default,UiSelectComponent: require('/home/node/app/components/ui/SelectComponent.vue').default,UiButtonComponent: require('/home/node/app/components/ui/ButtonComponent.vue').default,ControllerCustomForm: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerCustomForm.js').default})
